export const comments_3374307 = {"data":{"data":[],"links":{}}}